import {
  ArcElement,
  BarController,
  BarElement,
  CategoryScale,
  Chart,
  Filler,
  Legend,
  LineController,
  LineElement,
  LinearScale,
  PieController,
  PointElement,
  TimeScale,
  Title,
  Tooltip,
} from 'chart.js';
import {
  LineWithErrorBarsChart,
  LineWithErrorBarsController,
  PointWithErrorBar,
} from 'chartjs-chart-error-bars';
import annotationPlugin from 'chartjs-plugin-annotation';
import zoomPlugin from 'chartjs-plugin-zoom';

export const makeChartJsRegistrations = () => {
  Chart.register(
    ArcElement,
    annotationPlugin,
    BarController,
    BarElement,
    CategoryScale,
    Filler,
    Legend,
    LinearScale,
    LineController,
    LineElement,
    LineWithErrorBarsChart,
    LineWithErrorBarsController,
    PieController,
    PointElement,
    PointWithErrorBar,
    TimeScale,
    Title,
    Tooltip,
    zoomPlugin
  );
};
